import React from 'react'
import { MemberIcon, MemberIconGroup, Size } from './PermissionGroupIcon.styles'
import styled from 'styled-components'

interface PermissionGroupIconProps {
  name: string
  className?: string
  size?: Size
  dark?: boolean
}

const PermissionGroupIcon = ({
  className,
  name,
  dark = false,
  size = '32px',
}: PermissionGroupIconProps) => {
  // We take the first character to use as an icon, we use `Array.from` to
  // allow emojis
  const parsedName = Array.from(name)[0]

  return (
    <MemberIconGroup className={className} $size={size} $dark={dark}>
      <MemberIcon $dark={dark}>{parsedName}</MemberIcon>
    </MemberIconGroup>
  )
}

export default styled(PermissionGroupIcon)``
